<template>
    <div class="sw-survey-container">
        <div class="sw-width-full" v-if="!success">
            <form ref="form" method="post" @submit.prevent="submit($event)">
                <div class="sw-contact-form">
                    <component :key="index" v-for="(component,index) of form.form_components"
                               :component="component"
                               :is="`form-${component.component}`"
                               :id="component.id">
                        <component v-if="component.children"
                                   :key="childIndex"
                                   :component="child"
                                   v-for="(child,childIndex) of component.children"
                                   :is="`form-${child.component}`"
                                   :id="child.id">
                        </component>
                    </component>
                </div>
                <div class="sw-mt-2 sw-ml-1 sw-mr-1">
                    <div class="sw-flex sw-mb-1 sw-align-center">
                        <input  class="form-checkbox sw-checkbox"
                                type="checkbox"
                                v-model="termsAndConditions">
                        <p class="sw-ml-1 sw-accept" v-html="form.settings.termsAndConditions"></p>
                    </div>
                    <div class="sw-flex sw-mb-1 sw-align-center">
                        <input class="form-checkbox sw-checkbox"
                               type="checkbox"
                               v-model="privacyPolicy">
                        <p class="sw-ml-1 sw-accept" v-html="form.settings.privacyPolicy"></p>
                    </div>
                </div>
                <div v-if="cantSubmitText.length" class="sw-flex sw-justify-end sw-container">
                    <p class="sw-bad">{{ cantSubmitText }}</p>
                </div>
                <div class="sw-flex sw-justify-end">
                    <button :class="{'opacity-50': loading}" type="submit" class="sw-btn">
                        {{getObjKey(form,'settings.submitButton.text')? getObjKey(form,'settings.submitButton.text') : 'Absenden' }}
                    </button>
                </div>
            </form>
        </div>
        <template v-else>
            <div id="sw-anchor-2"></div>
            <div class="sw-mx-auto sw-thanks-message">
                {{ form.thanks_message }}
            </div>
        </template>
    </div>
</template>

<script>
import FormCheckbox from "@/Pages/Forms/Partials/Checkbox.vue";
import FormColumn from "@/Pages/Forms/Partials/Column.vue";
import FormInput from "@/Pages/Forms/Partials/Input.vue";
import FormDate from "@/Pages/Forms/Partials/Date.vue";
import Form from "@/Pages/Forms/Partials/Form.vue";
import FormTextarea from "@/Pages/Forms/Partials/Textarea.vue";
import FormSelect from "@/Pages/Forms/Partials/Select.vue";
import FormButton from "@/Pages/Forms/Partials/Button.vue";
import FormScalaQuestion from "@/Pages/Forms/Partials/ScalaQuestion.vue";
import FormSlide from "@/Pages/Forms/Partials/Slide.vue";
import objHelper from "@/Helpers/objHelper.js";
import axios from "axios";

export default {
    name: "PublicContenderForm",
    components: {
        FormCheckbox,
        FormColumn,
        FormInput,
        FormDate,
        Form,
        FormTextarea,
        FormSelect,
        FormButton,
        FormScalaQuestion,
        FormSlide
    },
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            contactData: {},
            success: false,
            loading: false,
            cantSubmitText:'',
            termsAndConditions: false,
            privacyPolicy: false
        }
    },
    computed: {
        canSubmit() {
            return this.termsAndConditions && this.privacyPolicy;
        },
        origin() {
            if (typeof this.form.origin !== 'undefined') {
                return this.form.origin;
            }
            return 'https://tracker.schubwerk.de';
        }
    },
    methods: {
        ...objHelper,
        async submit($event) {
            if(this.canSubmit) {
                this.loading = true;
                $event.preventDefault()
                    await axios.post(this.origin+'/api/form/'+this.form.id+'/submit/application',
                    new FormData(this.$refs.form), {
                        method: "POST",
                        mode: 'cors',
                    }).then(() => {
                    this.loading = false;
                    this.success = true;
                }).catch(() => {
                    this.loading = false;
                });
            } else {
                this.cantSubmitText = 'Einige der Fragen wurden nicht beantwortet oder die Datenschutzerklärung wurde nicht ausgewählt.'
                setTimeout(() => {
                    this.cantSubmitText = ''
                }, 5000)
            }
        }
    }
}
</script>

<style scoped>

</style>
